<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div class="flex">
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Name')" :placeholder="$t('Labels.Name')" v-model="data.name"/>
                          </div>
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Port')" :placeholder="$t('Labels.Port')" v-model="data.port"/>
                          </div>
                        </div>
                        <div class="flex">
                          <div  class="flex-1 p-2">
                            <label>{{$t('Labels.Profile')}}</label>
                            <v-select :options="profiles" v-model="data.device_profile_uuid" :reduce="profile => profile.id_nw" label="name"/>
                          </div>
                          <div class="w-1/2 p-2">
                            <label>{{$tc('Labels.App',1)}}</label>
                            <v-select :options="apps" v-model="data.app_id" :reduce="app => app.id_nw" label="name"/>
                          </div>
                        </div>
                        <div class="text-right">
                            <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled" :disabled="!valid">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect
  },

  data () {
    return {
      profiles: [],
      apps: [],
      data:{
        port: '',
        app_id: '',
        name: '',
        device_profile_uuid: ''
      }
    }
  },

  methods: {
    async getApps () {
      this.$vs.loading()

      const params = {
        url: 'applications',
        method: 'GET',
        params:{
          limit:10000,
          offset:0,
          byColumn:'name',
          byOrder:'asc'
        }
      }
      await request(params).then(response => {
        this.apps = response.data.data.rows
        this.apps.unshift({
          id_nw:0,
          name: this.$t('Labels.SelectOne')
        })
        this.data.app_id = 0
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    async getProfiles () {
      this.$vs.loading()

      const params = {
        url: 'device_profiles',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.profiles = response.data.data
        this.profiles.unshift({
          id_nw:0,
          name: this.$t('Labels.SelectOne')
        })
        this.data.device_profile_uuid = 0
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    requestPassword () {
      globalPassActions.show()
    },
    async add () {
      const params = {
        url: 'device_types',
        method: 'POST',
        params: this.data
      }
      await request(params).then(response => {
        window.location.href = '/types/'
      })  
    }
  },
  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.DeviceTypes')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Add')
    this.$route.meta.pageTitle = this.$t('Path.Add')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getProfiles()
    this.getApps()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    },
    valid () {
      return (this.data.device_profile_uuid != 0 && this.data.app_id != 0 && !empty(this.data.name) && !empty(this.data.port))
    }
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.add()
    }
  }
}
</script>
